'use client'
import {
   AdaptabilityIcon,
   CareerGrowthIcon,
   FlexibilityIcon,
   InclusivityIcon,
   InnovativeSolutionsIcon,
   SocialConnectionsIcon,
   TeamworkIcon,
   WorkLifeBalance,
} from '@/svgs/discover-benzatine'
import Image from 'next/image'
import React from 'react'

const cultureItems = [
   {
      icon: <InclusivityIcon />,
      title: 'INCLUSIVITY',
      description:
         'The company embraces diversity by creating an environment which provides space for every employee to share their ideas and receive equal treatment. Our organization has created an environment where diversity helps people bring their ideas while maintaining respectful relations among employees who work collaboratively.',
   },
   {
      icon: <FlexibilityIcon />,
      title: 'FLEXIBILITY',
      description:
         'We believe in work-life harmony. Our adaptable policies let staff organize their work times with efficiency which enhances both productivity and individual well-being without requiring them to give up their personal responsibilities.',
   },
   {
      icon: <TeamworkIcon />,
      title: 'TEAMWORK',
      description:
         'Our organization finds its success through team collaboration. Our organization promotes both open dialogues and team-based problem resolution methods which ensure the successful achievement of united project objectives.',
   },
   {
      icon: <AdaptabilityIcon />,
      title: 'ADAPTABILITY',
      description:
         'The ability to adapt shapes success because our modern world demands continuous adjusting. Our team benefits from empowerment to adapt to changes and get new expertise and industry insights for sustained advancement and creative developments.',
   },
   {
      icon: <WorkLifeBalance />,
      title: 'WORK-LIFE BALANCE',
      description:
         'The performance level benefits from work-life balance control. Our organization maintains a culture based on employee support which makes mental well-being along with personal development and family time and self-care commitments our highest priority.',
   },
   {
      icon: <SocialConnectionsIcon />,
      title: 'SOCIAL CONNECTIONS',
      description:
         'Beyond work, we nurture strong professional relationships through team activities, networking events, and social engagements, fostering a sense of belonging and camaraderie.',
   },
   {
      icon: <CareerGrowthIcon />,
      title: 'CAREER GROWTH',
      description:
         'We invest in our people. Through mentorship, learning opportunities, and career advancement programs, we empower employees to achieve their full potential and long-term success.',
   },
   {
      icon: <InnovativeSolutionsIcon />,
      title: 'INNOVATIVE SOLUTIONS',
      description: `Creativity drives us forward. We foster innovative ideas, experimentation, and technology advancements to create edge solutions that define our industry's future.`,
   },
]

function OurWorkCultureSection() {
   return (
      <>
         <section className="curve_image p-0 section_secondary_bg">
            <div className="culture_bg">
               <img src="/assets/svg/cluture_bg.svg" alt="Culture Background" />
            </div>
            <Image
               width={3840}
               height={1921}
               src="/assets/image/DiscoverPage/group.jpg"
               alt="group"
            />
         </section>

         <section className="section_secondary_bg work_culture p-0">
            <div className="container text-center work_culture_head">
               <h2 className="section_heading_title mb-3 tech_title">
                  Our Work Culture
               </h2>
               <p className="intro_description">
                  At Benzatine Infotech we encourage an open atmosphere based on
                  teamwork which enables each team member to submit their
                  creativity toward innovative problem-solving. The fluid
                  workspace at Benzatine Infotech gives all members open access
                  to ongoing training opportunities while preserving their
                  individual input.
               </p>
            </div>
            <div className="work_cluture_details">
               <div className="container">
                  <div className="culture_grid">
                     {cultureItems.map((item, index) => (
                        <React.Fragment key={item.title}>
                           <div className="culture_item">
                              <div className="culture_icon">{item.icon}</div>
                              <h3>{item.title}</h3>
                              <p>{item.description}</p>
                           </div>
                           {index === 3 && <div className="divider"></div>}
                        </React.Fragment>
                     ))}
                  </div>
               </div>
            </div>
         </section>
      </>
   )
}

export default OurWorkCultureSection
